import { inject, Injectable } from '@angular/core';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
    private readonly _fuseConfirmationService = inject(FuseConfirmationService);
    private _armed = false;
    private _isOpen = false;

    arm(): void {
        this._armed = true;
    }

    notifyUnavailable(): void {
        if (!this._armed || this._isOpen) {
            return;
        }
        this._isOpen = true;
        this._fuseConfirmationService.open({
            title: 'Can\'t reach the server',
            message: 'Dante TMS could not connect. This is usually temporary.',
            icon: { name: 'heroicons_outline:exclamation-triangle', color: 'warning' },
            actions: {
                confirm: { label: 'Reload page', color: 'primary' },
                cancel: { label: 'Dismiss' }
            }
        }).afterClosed().subscribe((result) => {
            this._isOpen = false;
            if (result === 'confirmed') {
                location.reload();
            }
        });
    }
}
